import type {Context} from '../types';

const supportedLinkTypes = [
  'Link',
  'NavbarLink',
  'DropdownLink',
  'NavbarBrand',
];

export default (context: Context) => {
  const {jsonNode} = context.node;
  const {data = {}} = jsonNode;

  const linkNode = jsonNode.type && supportedLinkTypes.includes(jsonNode.type);
  const hasMode = data.link?.hasOwnProperty('mode');
  const hasUrl = data.link?.hasOwnProperty('url');

  const urlNoMode = !hasMode && hasUrl;
  const wrongDynpage =
    data.link?.mode === 'dynpage' &&
    (data.link?.hasOwnProperty('itemId') ||
      data.link?.hasOwnProperty('collectionId'));

  if (linkNode && urlNoMode) {
    return {
      needed: true,
      logData: {
        msg: 'Set mode=external for link that had no mode, but did have url configured.',
        meta: {
          nodeId: jsonNode._id,
        },
      },
      apply: () => {
        data.link.mode = 'external';
      },
    };
  }

  if (linkNode && wrongDynpage) {
    return {
      needed: true,
      logData: {
        msg: 'Set mode=page for rich text CMS item page link that had incorrect dynpage mode.',
        meta: {
          nodeId: jsonNode._id,
        },
      },
      apply: () => {
        data.link.mode = 'page';
      },
    };
  }

  return {
    needed: false,
    logData: {
      msg: 'Patch 097 not needed',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => undefined,
  };
};
